import { render } from "./PerformanceOverviewChart.vue?vue&type=template&id=07fd3aaf&ts=true"
import script from "./PerformanceOverviewChart.vue?vue&type=script&lang=ts"
export * from "./PerformanceOverviewChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__